import { Injectable } from '@angular/core';
import { CosmosDb } from 'lib/cosmos/cosmosDb.js';
import { UserDb } from 'lib/cosmos/user/userDb.js';
import { roundHelper } from 'lib/helpers/round.helper.class.js';
import { CoreTimeService } from 'lib/time/core-time.service.js';

export interface ITrialState {
	readonly daysRemaining: number;
	readonly isExpired: boolean;
}

export interface ITrialStateUser {
	readonly userType: UserDb.UserType;
	readonly license: UserDb.UserLicense;
	readonly privilege: CosmosDb.CosmosUserPrivilege;
	readonly created: string;
}

@Injectable({
	providedIn: 'root'
})
export class TrialService {
	public readonly trialLengthInDays: number = 14;
	private readonly timeService = new CoreTimeService();

	constructor() {}

	getTrialState(user: ITrialStateUser | undefined): ITrialState {
		if (!user) {
			return {
				daysRemaining: 0,
				isExpired: false
			};
		}

		if (user.userType === 'client') {
			return {
				daysRemaining: 0,
				isExpired: false
			};
		}

		if (user.license === 'premium' || user.privilege === 'admin') {
			return {
				daysRemaining: 0,
				isExpired: false
			};
		}

		const trialDays: number = roundHelper.roundTo(
			this.timeService.getDifferenceInDays(this.timeService.now(), user.created),
			0
		);

		let daysRemaining = this.trialLengthInDays - trialDays;

		if (daysRemaining < 0) {
			daysRemaining = 0;
		}

		return {
			daysRemaining: daysRemaining,
			isExpired: daysRemaining === 0
		};
	}
}
